import { Component } from '@angular/core';

@Component({
  selector: 'app-hosting-blog',
  templateUrl: './hosting-blog.component.html',
  styleUrls: ['./hosting-blog.component.css']
})
export class HostingBlogComponent {
  navClass = 'nav-light';
    // Set Topbar Option
  Menuoption = 'hosting';
  Settingicon = true
  footerVariant = 'footer-ten';
}
